import $ from "jquery";
import "@accessible360/accessible-slick";

export default class Slider {
  /**
   * creates an instance of the slider
   * @param {string} sliderSelector selector for the slider
   * @param {object} setup slider settings
   */

  constructor(sliderSelector, setup = {}) {
    this.$slider = $(sliderSelector);


    // misc
    this.breakpointSm = 768;
    this.breakpointMd = 1440;
    this.breakpointXl = 1920;
    this.breakpointXxl = 100000;

    const _defaults = {
      focusOnSelect: true,
      slidesToShowXxl: 3,
      slidesToShowSm: 1,
      slidesToScrollDesktop: 1,
      slidesToScrollMedium: 1,
      arrows: false,
      centerMode: false,
      dots: true,
      variableWidth: false,
      variableWidthSm: false,
      adaptiveHeight: false,
      infinite: false,
      vertical: false,
      verticalSwiping: false,
      swipeToSlide: true
    };

    this.setup = Object.assign({}, _defaults, setup);

    // jQuery-objects
    this.$activeSlider = null;

    // variables
    this.windowWidth = $(window).outerWidth(true);

    this.init();
  }

  recalculateHeight = () => {
    this.$slider.find('.slick-slide').css('height', this.$slider.find('.slick-track').height() + 'px');
  };

  /**
   * handle slider- and window-events
   */
  handleEvents = () => {
    // get all slides
    this.slickSlides = this.$slider.find(".slick-slide").toArray();
    // Function to set the height of each element to its width
    function setHeightToWidth(elements) {
      elements.forEach(function (element) {
        var $element = $(element);
        var width = $element.css("width");
        $element.css("height", width);
      });
    }
    // set slide height to width
    setHeightToWidth(this.slickSlides);

    //setPosition event listener
    this.$slider.on('setPosition', function (event, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });

    // re-initialize slider-elements if breakpoint is reached (solve slick-bug !?)
    this.$slider.on("breakpoint", () => {
      this.$sliderNextArrows = this.$activeSlider.$nextArrow;
      this.$sliderPrevArrows = this.$activeSlider.$prevArrow;
      this.$dots = this.$activeSlider.$dots;

      // re-set the slider controls
      // this.setSliderControls(this.$activeSlider);
    });

    // on beforeChange event
    this.$slider.on("beforeChange edge", (slick, currentSlide) => {
      let $teaser = currentSlide.$slides.find("[data-js-teaser]");

      // disable data-link to prevent click-event on slide
      $teaser.attr("data-link", "off");
    });

    // on afterChange event
    this.$slider.on("afterChange", (slick, currentSlide) => {
      let $teaser = currentSlide.$slides.find("[data-js-teaser]");

      // enable data-link when slide has finished
      $teaser.attr("data-link", "on");
    });
  };

  /**
   * initialize slick
   */
  init = () => {
    $(this.$slider).slick({
      slidesToShow: this.setup.slidesToShowXxl,
      slidesToScroll: this.setup.slidesToScrollDesktop,
      arrows: this.setup.arrows,
      centerMode: this.setup.centerMode,
      dots: this.setup.dots,
      variableWidth: this.setup.variableWidth,
      adaptiveHeight: this.setup.adaptiveHeight,
      infinite: this.setup.infinite,

      responsive: [
        {
          // slick-settings from 390 to 767
          breakpoint: this.breakpointSm,
          settings: {
            slidesToShow: this.setup.slidesToShowSm,
            arrows: this.setup.arrowsSm,
          }
        },
        {
          // slick-settings from 768 to 1440
          breakpoint: this.breakpointMd,
          settings: {
            slidesToShow: this.setup.slidesToShowMd
          }
        },
        {
          // slick-settings from 1366 to 1919
          breakpoint: this.breakpointXl,
          settings: {
            slidesToShow: this.setup.slidesToShowXl
          }
        },
        {
          // slick-settings from 1920 to 100.000 (Workaround to trigger breakpoint event)
          breakpoint: this.breakpointXxl,
          settings: {
            slidesToShow: this.setup.slidesToShowXxl
          }
        }
      ]
    });

    // initialize slick
    this.$activeSlider = this.$slider.slick("getSlick");

    // methods
    // this.setSliderControls(this.$activeSlider);
    this.handleEvents();
    this.recalculateHeight();
  };
}

$(function () {
  $(document).ready(function () {
    // Initialize the slider for elements with the class 'egat-slider'
    $(".egat-slider").each(function () {

      setTimeout(() => {
        const $slider = $(this);
        const sliderType = $slider.data("slidertype");
        if(sliderType === 'content'){
          new Slider(this, {
            infinite: false,
            arrows: true,
            arrowsSm: false,
            slidesToShowSm: 1, // Show 1 slide for the smallest breakpoint
            slidesToShowMd: 1, // Show 1 slides for medium breakpoints
            slidesToShowXl: 1, // Show 1 slides for extra-large breakpoints
            slidesToShowXxl: 1, // Show 1 slides for larger breakpoints
            slidesToScrollDesktop: 1,
            slidesToScrollMedium: 1
          });
        }
        else {
          new Slider(this, {
            infinite: true,
            slidesToShowSm: 1, // Show 1 slide for the smallest breakpoint
            slidesToShowMd: 2, // Show 2 slides for medium breakpoints
            slidesToShowXl: 3, // Show 3 slides for extra-large breakpoints
            slidesToShowXxl: 3, // Show 3 slides for larger breakpoints
            slidesToScrollDesktop: 3,
            slidesToScrollMedium: 2
          });
        }
      }, 200);
    });
  });
});
